import React from "react";
import ShopifyImage from "./ShopifyImage";
import Button from "./Button";
const CollectionOption = ({ collection, handleSetCollection }) => {
    return (
        <div className="collection-option" onClick={() => handleSetCollection(collection)}>
            <ShopifyImage image={collection.image} />
            <h3 className="Heading">{collection.title}</h3>
            <Button>Select</Button>
        </div>
    );
    }

export default CollectionOption;